import { styled } from '@mui/material';

import { Theme } from '../../theme';
import { Paragraph } from '../Paragraph';

import { PromoCardColor } from './PromoCard.types';

export const promoCardColorTheme = (customTheme: Theme) => ({
    Orange: {
        color: customTheme.palette.common.blue,
        backgroundColor: customTheme.palette.pino.ultimate,
    },
    Cyan: {
        color: customTheme.palette.common.blue,
        backgroundColor: customTheme.palette.pino.standard,
    },
    Navy: {
        color: customTheme.palette.common.white,
        backgroundColor: customTheme.palette.common.blue,
    },
    Grey: {
        color: customTheme.palette.common.white,
        backgroundColor: customTheme.palette.mbtOptimizationPino.offPeak,
    },
    'Electric Green': {
        color: customTheme.palette.common.blue,
        backgroundColor: customTheme.palette.secondary.main,
    },
});

export const StyledCardHeader = styled('header')<{ $color: PromoCardColor }>`
    ${({ theme, $color }: { theme: Theme; $color: PromoCardColor }) => {
        const colorTheme = promoCardColorTheme(theme)[$color];
        return `
            position: relative;
            display: flex;
            flex-direction: column;
            gap: ${theme.tggSpacing(2)};
            padding: ${theme.tggSpacing(2)};
            color: ${colorTheme.color};
            background-color: ${colorTheme.backgroundColor};

            .promoCardPill {
                position: absolute;
                top: ${theme.tggSpacing(0)};
                right: ${theme.tggSpacing(2)};
            }

            ${theme.breakpoints.up('desktop')} {
                gap: ${theme.tggSpacing(3.5)};
                padding: ${theme.tggSpacing(4)};
            }
        `;
    }}
`;

export const StyledCardTitle = styled('div')`
    ${({ theme }) => theme.typography.text_14_bold_desktop_16}
`;

export const StyledCardHeadline = styled('div')`
    ${({ theme }) => theme.typography.text_28_bold_lh_15_desktop_36}
`;

export const StyledCardBody = styled('div')`
    ${({ theme }) => `
        padding: ${theme.tggSpacing(2)};
        background-color: ${theme.palette.tgg.surface.container.main};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(4)};
        }
    `}
`;

export const StyledCardSubHead = styled('div')`
    ${({ theme }) => theme.typography.text_16_bold_lh_20_desktop_19}
    ${({ theme }) => `
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${theme.tggSpacing(2)};
        }
    `}
`;

export const StyledCardDescription = styled(Paragraph)`
    ${({ theme }) => theme.typography.text_12_lh_20_desktop_14_lh_22}
    ${({ theme }) => `
        color: ${theme.palette.common.blue};
    
    `}
`;
